export default __webpack_public_path__ + "static/media/017-peas.17596896.svg";